import cookie from "vue-cookies";
import FeatureFlagService from "@emcd-shared/feature-flag-service/feature-flag.service.js";
import { convertStringToEnglishLetters } from "@/shared/lib/convertStringToEnglishLetters";

function initState() {
  return {
    loadingSub: false,
    webWalletsDisableWithdrawToCardFlag: undefined,
    webWalletsKycRestrictions: undefined,
    hideZeroBalance: !!cookie.get("hideZeroBalance"), // Checkbox state on the Index page about hiding zero balances
    searchCoinOnIndexPage: "", // Content of search input on the index page, usually with coin title or description
  };
}

const state = initState();

const mutations = {
  SET_LOADING_SUB(state, payload) {
    state.loadingSub = payload;
  },

  SET_FEATURE_FLAG(state, payload) {
    state.webWalletsDisableWithdrawToCardFlag =
      payload.webWalletsDisableWithdrawToCard;
    state.webWalletsKycRestrictions = payload.webWalletsKycRestrictions;
  },

  setSearchCoinOnIndexPage(state, payload) {
    state.searchCoinOnIndexPage = payload;
  },

  setHideZeroBalance(state, payload) {
    state.hideZeroBalance = payload;
  },
};

const actions = {
  SET_LOADING_SUB: ({ commit }, payload) => {
    commit("SET_LOADING_SUB", payload);
  },

  FeatureFlagService: async ({ commit }) => {
    try {
      const response = await FeatureFlagService.init("WALLETS");
      commit("SET_FEATURE_FLAG", {
        webWalletsDisableWithdrawToCard: response.isEnabled(
          "webWalletsDisableWithdrawToCard",
        ),
        webWalletsKycRestrictions: response.isEnabled(
          "webWalletsKycRestrictions",
        ),
      });
    } catch (error) {
      console.error("Error: ", error);
    }
  },

  toggleHideZeroBalance: function ({ state, commit }) {
    commit("setHideZeroBalance", !state.hideZeroBalance);
    if (state.hideZeroBalance) {
      cookie.set("hideZeroBalance", true);
    } else {
      cookie.remove("hideZeroBalance");
    }
  },
};

const getters = {
  searchCoinConvertedToEnglishLetters(state) {
    return convertStringToEnglishLetters(state.searchCoinOnIndexPage);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
